import{visualizationFormatNumber as r}from"../../../utils/formatter.js";var t=function(t,n){if(t)return function(o){return""+r(o,t)+(n||"")}};export{t as getValueRenderer};
